/* eslint-disable no-shadow */
/* eslint-disable no-underscore-dangle */
/* global videojs */
import helpers from '../helpers';
import globals from '../globals';

const isMobile = helpers.isMobile();

const VideoTypes = {
	MP4: 'video/mp4',
	X_MPEG: 'application/x-mpegURL',
};

const getVideoType = (src) => {
	if (src.includes('mp4')) {
		return VideoTypes.MP4;
	}

	if (src.includes('m3u8')) {
		return VideoTypes.X_MPEG;
	}

	return null;
};

const initVideo = (page) => {
	$(page).find('video').each((index, item) => {
		const $video = $(item);
		const $parent = $video.parent();
		const videoPoster = item.dataset.poster;
		const btn = $parent.find('.video__play');

		let player = $parent.data('player');
		let video30secInterval = null;
		let isPlayed = false;

		const name = $video.data('name');
		const src = $video.data('src');

		if (player) {
			return;
		}

		player = videojs(item, {
			poster: videoPoster,
			loop: false,
			playsinline: true,
			preload: 'auto',
			aspectRatio: '16:9',
			html5: {
				nativeAudioTracks: false,
				nativeVideoTracks: false,
				nativeTextTracks: false,
			},
			hls: {
				overrideNative: true,
			},
		});

		player.src({
			src,
			type: getVideoType(src),
			withCredentials: true,
		});

		$parent.data('player', player);

		$(btn).on('click', () => {
			player.play();
		});

		player.on('play', () => {
			btn.hide();
			$('.player').each((index, elem) => {
				elem.dataset.player = 'pause';
				const audio = elem.querySelector('audio');
				audio.pause();
			});
			if (isMobile) {
				player.requestFullscreen();
			}

			if (!isPlayed) {

				ga('send', 'event', 'video', 'play', name, {nonInteraction: true});
				ga('rbcspec.send', 'event', 'video', 'play', {nonInteraction: true});

				isPlayed = true;
			}

			// clearInterval(video30secInterval);

			video30secInterval = setInterval(() => {
				ga('send', 'event', 'video', 'timing 30s', name, 30);
				ga('rbcspec.send', 'event', 'video', 'timing 3s', '', 30);
			}, 30000);
		});

		player.on('pause', () => {
			clearInterval(video30secInterval);
		});

		player.on('ended', () => {
			ga('send', 'event', 'video', 'finish', name);
			ga('rbcspec.send', 'event', 'video', 'finish');

			clearInterval(video30secInterval);
		});

		globals.$document.on('videoStop', () => {
			player.pause();
			player.currentTime(0);
		});

		player.on('fullscreenchange', () => {
			const isFullscreen = player.isFullscreen();
			if (!isFullscreen) {
				$parent.removeClass('fullscreen');
				if (isMobile) {
					player.pause();
				}
			} else {
				$parent.addClass('fullscreen');
			}
		});
	});
};

export {initVideo};
